<div class="content">
  <div class="selectors-box flex column">
    <!-- Filter chips -->
    <div class="filter-chips-container">
      <app-client-reference-id-filter [control]="clientReferenceId"></app-client-reference-id-filter>
      <app-client-name-filter [control]="clientName"></app-client-name-filter>
      <app-client-tax-number-filter [control]="clientTaxNumber"></app-client-tax-number-filter>
      @if (hasActiveFilters) {
        <button
          class="clear-all-filters-btn"
          (click)="clearAllFilters()"
        >
          Szűrők törlése
        </button>
      }
    </div>

    <!-- Action buttons -->
    <div class="selector-row flex vcenter">
      <button
        payee-button
        (click)="createClient()"
      >
        Új hitelező
      </button>
    </div>

    @if (selectedClientForMerge) {
      <div class="flex vcenter selected-client-box">
        <div class="grow1">
          <div class="selected-client-label">Kiválasztott hitelező összevonáshoz:</div>
          <div class="flex vcenter selected-client-info">
            <span class="selected-client-name">
              {{ selectedClientForMerge.name }}
            </span>
            <span class="selected-client-tax">
              {{ selectedClientForMerge.tax_number }}
            </span>
          </div>
        </div>
        <button
          payee-icon-button
          color="white"
          aria-label="Törlés"
          (click)="cancelMerge()"
        >
          <payee-icon name="cross-black"></payee-icon>
        </button>
      </div>
    }
  </div>

  <table
    mat-table
    custom-table
    multiTemplateDataRows
    matSort
    class="mat-elevation-z1"
    [dataSource]="dataSource"
    (matSortChange)="sortData($event)"
  >
    <ng-container matColumnDef="client_reference_id">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Ügyfélazonosító
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <div
          class="client-id-box flex vcenter"
          matTooltipPosition="above"
          matTooltipClass="client-id-tooltip"
          role="button"
          tabindex="0"
          (click)="copyIdToClipboard(element, $event)"
          (keydown.enter)="copyIdToClipboard(element, $event)"
          (keydown.space)="copyIdToClipboard(element, $event); $event.preventDefault()"
        >
          <span class="client-id-text">{{ element.client_reference_id }}</span>
          <payee-icon
            name="copy-blue"
            width="14px"
            height="14px"
            class="client-id-icon"
          ></payee-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Hitelező neve
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="tax_number">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Hitelező adószáma
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.tax_number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="open_cases">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Futó ügyek
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.open_cases }}
      </td>
    </ng-container>

    <ng-container matColumnDef="closed_cases">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Lezárt ügyek
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.closed_cases }}
      </td>
    </ng-container>

    <ng-container matColumnDef="auto_start_hard_2">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-header
      >
        VH automatikus indítása
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <mat-checkbox
          [disabled]="updateLoading || !element.uses_credits"
          [checked]="element.auto_start_hard_2"
          (click)="$event.stopPropagation()"
          (change)="toggleAutoStartHard2(element, $event)"
        ></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="uses_credits">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-header
      >
        Kreditek használata
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <mat-checkbox
          [disabled]="updateLoading"
          [checked]="element.uses_credits"
          (click)="$event.stopPropagation()"
          (change)="toggleUsesCredits(element, $event)"
        ></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="credits">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-header
      >
        Kreditek (elérhető/használt)
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        @for (credit of element.credits; track credit.currency_iso) {
          <div>
            {{ credit.remaining | currency: credit.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
            /
            {{ credit.used | currency: credit.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
          </div>
        }
        @if (element.credits.length === 0) {
          <div>-</div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          payee-icon-button
          color="white"
          [matMenuTriggerFor]="actionsMenu"
          (click)="$event.stopPropagation()"
        >
          <payee-icon name="more-blue"></payee-icon>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <button
            mat-menu-item
            (click)="createCase(element)"
          >
            Ügy létrehozása
          </button>
          <button
            mat-menu-item
            (click)="navigateToCases(element)"
          >
            Hitelező ügyei
          </button>
          <button
            mat-menu-item
            (click)="editClient($event, element)"
          >
            Hitelező szerkesztése
          </button>
          <button
            mat-menu-item
            (click)="selectClientForMerge(element)"
          >
            Összevonás
          </button>
          <button
            mat-menu-item
            (click)="addCredit(element)"
          >
            Kredit feltöltése
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <!-- Expanded Content Column -->
    <ng-container matColumnDef="expandedDetail">
      <td
        *matCellDef="let element"
        mat-cell
        [attr.colspan]="displayedColumns.length"
      >
        <div class="element-detail alt-theme flex column">
          @if (element === expandedElement && !!expandedElementData) {
            <div class="client-details flex">
              <div>
                @if (expandedElementData.client.bank_account) {
                  <div class="bank-account-details">
                    <h1>Bankszámla</h1>
                    <span>Kedvezményezett: {{ expandedElementData.client.bank_account.account_holder_name }}</span>
                    <span>Bankszámla: {{ expandedElementData.client.bank_account.account_number }}</span>
                    <span>IBAN: {{ expandedElementData.client.bank_account.iban }}</span>
                    <span>BIC: {{ expandedElementData.client.bank_account.bic }}</span>
                    <span>Bank Neve: {{ expandedElementData.client.bank_account.bank_name }}</span>
                  </div>
                }
                <h1>Cím</h1>
                <span>{{ expandedElementData.client.address }}</span>
                <h1>Felhasználók</h1>
                @for (user of expandedElementData.users; track user.email) {
                  <div>{{ user.name }} &lt;{{ user.email }}&gt;</div>
                }
              </div>
              @if (expandedElementData.client.credit_history.length > 0) {
                <div class="credit-history flex column">
                  <h1>Kreditek</h1>
                  <table>
                    @for (line of expandedElementData.client.credit_history; track line.date + line.label + line.amount) {
                      <tr>
                        <td>{{ line.date }}</td>
                        <td>{{ line.label }}</td>
                        <td>{{ line.amount }}</td>
                      </tr>
                    }
                  </table>
                </div>
              }
              @if (expandedElementData.client.credit_transfers.length > 0) {
                <div class="credit-transfers flex column">
                  <h1>Kredit tranzakciók</h1>
                  <table>
                    @for (line of expandedElementData.client.credit_transfers; track line.id) {
                      <tr>
                        <td>{{ line.created_at }}</td>
                        <td>{{ line.state }}</td>
                        <td>
                          {{ line.amount | currency: line.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
                        </td>
                        <td>
                          @if (line.state === "pending") {
                            <button
                              payee-button
                              width="shorter"
                              (click)="payCreditTransfer(line)"
                            >
                              Befizetés rögzítése
                            </button>
                          }
                        </td>
                      </tr>
                    }
                  </table>
                </div>
              }
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr
      *matHeaderRowDef="displayedColumns"
      mat-header-row
    ></tr>
    <tr
      *matRowDef="let element; columns: displayedColumns"
      mat-row
      class="element-row"
      [class.expanded-row]="expandedElement === element"
      (click)="updateExpandedElement(element)"
    ></tr>
    <tr
      *matRowDef="let row; columns: ['expandedDetail']"
      mat-row
      class="detail-row"
    ></tr>
  </table>

  <mat-paginator
    disableUnderline
    class="mat-elevation-z1"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[1, 5, 10, 25, 100]"
    [length]="length"
    (page)="pageChange($event)"
  ></mat-paginator>
</div>
